<app-dialog
  [dialogType]="dialogType"
  [preventCloseOnEsc]="true"
  [hideCloseButton]="true"
  [hideActions]="true"
>
  <i2g-loader [loaderText]="loadingTitle" [horizontal]="false"></i2g-loader>
</app-dialog>
